<template>
  <div class="document-group-type">
    <h3 class="type-header" @click.stop="$refs[`type-modal-${type.id}`].show()"><i class="float-right fa fa-cloud-upload" aria-hidden="true"></i>
      Uploaden: {{ type.name }}</h3>
    <p class="document-type-description" v-if="description" v-html="description"></p>
    <a class="example-doc-link" target="_blank" v-if="type.example" :href="`${baseUrl}${type.example}`">
      Voorbeeld document bekijken
    </a>

    <div class="current-documents" v-if="type.currentDocuments.length > 0">
      <table class="table table-borderless table-sm">
        <tr v-for="(document, index) in type.currentDocuments">
          <td>
            {{ nameOfDocumentOwner(document) }}
            <br>
          </td>
          <td class="text-center"><b><span class="d-none d-sm-inline">document </span>toegevoegd</b></td>
          <td class="text-right">
            <span class="action-buttons">
              <span @click.stop="download(document)">
                <i class="action-button view fa fa-eye"></i>
              </span>
              <span @click.stop="remove(document.id, index)">
                <i class="action-button delete fad fa-trash"></i>
              </span>
            </span>
          </td>
        </tr>
      </table>
    </div>

    <b-modal
            cancel-disabled
            size="lg"
            :id="`type-modal-${type.id}`"
            :ref="`type-modal-${type.id}`"
            :title="type.name"
    >

      <p>{{ type.popup }}</p>
      <hr>
      <p>
        Let op! Op sommige documenten staat een burgerservicenummer (BSN) vermeld. Zorg er voor dat dit BSN niet
        zichtbaar is in het document dat u toevoegt.<br/>
        U kunt alleen documenten uploaden van de bestandtypes gif, jpg, jpeg, pdf en png.
      </p>
      <template v-if="!uploading">
        <error-box v-if="postErrors.length > 0" :errors="postErrors"/>
        <div class="mt-2">
          <b-row class="file-line">
            <b-col sm="4"><span class="primary-text"><i class="fa fax fa-user"></i> Uw document</span></b-col>
            <b-col sm="4">{{ personName }}</b-col>
            <b-col sm="4">
<!--              <b v-if="didAnUpload">Document toegevoegd</b>-->
              <template v-if="personCanUpload">

                <label :for="`file-${type.id}`" class="file-upload-label">
                  Bestand toevoegen <i class="fa fax fa-plus"></i>
                </label>
                <input type="file" :id="`file-${type.id}`" :ref="`file-${type.id}`"
                       v-on:change="handleFileUpload(false)"
                       accept=".jpg,.jpeg,.pdf,.gif,.png"/>
              </template>


            </b-col>
          </b-row>

          <b-row class="file-line" v-if="partnerExists">
            <b-col sm="4"><i class="fa fax fa-user"></i> Partner document</b-col>
            <b-col sm="4">{{ partnerName }}</b-col>
            <b-col sm="4">
              <template v-if="partnerCanUpload">
                <label :for="`file-partner-${type.id}`" class="file-upload-label">
                  Bestand toevoegen <i class="fa fax fa-plus"></i>
                </label>
                <input
                        type="file"
                        :id="`file-partner-${type.id}`"
                        :ref="`file-partner-${type.id}`"
                        v-on:change="handleFileUpload(true)"
                        accept=".jpg,.jpeg,.pdf,.gif,.png"
                />
              </template>
              <template v-if="!partnerCanUpload">Document reeds geupload</template>
            </b-col>
          </b-row>

        </div>
      </template>

      <form-loader v-if="uploading" message="uploading..."/>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="success" @click="ok()">
          Verder
        </b-button>
      </template>
    </b-modal>

    <b-modal
    ok-only
        ok-title="sluiten"
        size="lg"
        :id="`error-modal-1`"
        @ok="$bvModal.hide(`error-modal-1`)"
    >
    <h2>
      Fout
      </h2>
      <p>
        Verwijderen is momenteel niet mogelijk omdat u een lopende aanbieding heeft.
      </p>
    </b-modal>

    <b-modal
        ok-only
        ok-title="sluiten"
        size="lg"
        :id="`confirmUpload-modal-${type.id}`"
        @ok="$bvModal.hide(`type-modal-${type.id}`)"
    >
      <h2>
        Upload gelukt
      </h2>
      <p>
        Uw document is geupload.
      </p>
    </b-modal>

  </div>
</template>
<script>
import FormLoader from '@/components/_registration/FormLoader'
import { documentService } from '@/_services/document.service'
import ErrorBox from '@/components/_registration/ErrorBox'
import dateTransformers from '@/mixins/dateTransformers'
import { decodeHtmlEntities } from '@/_helpers/html'

const viewableExtensions = {
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  pdf: 'application/pdf',
  png: 'image/png'
}

export default {
  data: () => {
    return {
      file: null,
      uploading: false,
      postErrors: [],
    }
  },
  components: { FormLoader, ErrorBox },
  props: {
    index: {
      type: Number,
      default: null,
    },
    personCanUpload: {
      type: Boolean,
      default: true,
    },
    partnerCanUpload: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Object,
      default: () => {
        return {
          description: '',
          id: '',
          name: '',
          example: '',
          popup: '',
          currentDocuments: [],
          didAnUpload: false
        }
      }
    },
    summary: {
      type: Object,
      default: () => {}
    },
  },
  computed: {
    description: function () {
      return decodeHtmlEntities(this.type.description)
    },

    baseUrl: function () {
      return process.env.VUE_APP_CF_BASE
    },
    partnerExists: function () {
      return !(this.summary.partner === undefined || !this.summary.partner.hasPartner)
    },

    partnerName: function () {
      if (!this.partnerExists) {
        return ''
      }
      return `${this.summary.partner.initials} ${this.summary.partner.lastname}`
    },

    personName: function () {
      return `${this.summary.person.initials} ${this.summary.person.lastname}`
    },
  },
  mixins: [dateTransformers],

  methods: {
    nameOfDocumentOwner (document) {
      if (document.partner) {
        return this.partnerName
      }
      return this.personName
    },

    handleFileUpload (forPartner) {
      this.uploading = true
      let file = (forPartner) ? this.$refs[`file-partner-${this.type.id}`].files[0] : this.$refs[`file-${this.type.id}`].files[0]

      documentService.postDocument(this.type.id, file, forPartner).then(result => {
        if (typeof result === 'object' && result !== null && 'errors' in result) {
          this.postErrors = result.errors
        } else {
          this.postErrors = []
          this.$emit('file-upload', result, this.index)
        }
      }).catch((error) => {
        console.log(error)
        alert('oops er is iets fout gegaan. Herlaad de pagina en probeer het opnieuw.')
      }).finally(() => {
        this.didAnUpload = true
        this.$bvModal.show(`confirmUpload-modal-${this.type.id}`)
        this.uploading = false
      })
    },

    download (currentDocument) {
      const id = currentDocument.id

      documentService.download(id).then(file => {
        const filename = this.documentFilename(currentDocument, file.filename)
        const blob = this.blobWithBrowserType(file.blob, filename)
        const fileURL = window.URL.createObjectURL(blob)
        const fileLink = document.createElement('a')

        fileLink.href = fileURL

        if (this.canOpenInBrowser(blob, filename)) {
          fileLink.target = '_blank'
          fileLink.rel = 'noopener noreferrer'
        } else {
          fileLink.setAttribute('download', filename)
        }

        document.body.appendChild(fileLink)
        fileLink.click()
        document.body.removeChild(fileLink)
        window.setTimeout(() => window.URL.revokeObjectURL(fileURL), 60000)
      }).catch(error => {
        console.error(error)
        alert('Er is iets fout gegaan, herlaad de pagina en probeer het opnieuw')
      })
    },

    documentFilename (document, responseFilename) {
      return responseFilename || document.filename || document.fileName || document.name || `document-${document.id}`
    },

    blobWithBrowserType (blob, filename) {
      if (blob.type && blob.type !== 'application/octet-stream') {
        return blob
      }

      const mimeType = this.mimeTypeFromFilename(filename)

      if (!mimeType) {
        return blob
      }

      return new Blob([blob], { type: mimeType })
    },

    canOpenInBrowser (blob, filename) {
      return blob.type === 'application/pdf' || blob.type.indexOf('image/') === 0 || this.mimeTypeFromFilename(filename) !== null
    },

    mimeTypeFromFilename (filename) {
      const extension = filename.split('.').pop().toLowerCase()

      return viewableExtensions[extension] || null
    },

    remove (id, index) {
      documentService.destroy(id).then(result => {

        // console.log('result', result);

        if(result.error){
          this.$bvModal.show(`error-modal-1`)
        }else{
          this.$emit('file-removed', this.index, index)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.document-group-type {
  color: #333;
  margin-bottom: 20px;

  &:last-of-type {
    margin-bottom: 0;
}
}

input[type="file"] {
  display: none;
}

.document-type-description {
  margin-bottom: 0;
}

.example-doc-link {
  display: block;
  margin-top: 5px;
}

.file-upload-label {
  cursor: pointer;

  i {
    color: #ffffff;
    background-color: #009e0f;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: unset;
  }
}

.table {
  margin-bottom: 0;

  td {
    padding: 3px 0;

    &:hover {
      cursor: default;
    }
  }
}


.action-buttons {
  text-align: justify;
}

.current-documents {
  margin-top: 5px;
  padding: 5px;
  background-color: #eee;
}

.action-button {
  cursor: pointer;
  font-size: 20px;

  &.view {
    color: #198EFD;
  }

  &.delete {
    color: #cf2a27;
    margin-left: 15px;
  }
}

.file-line {
  line-height: 33px;
}

.primary-text {
  color: #009e0f;

  i {
    font-size: 24px;
  }
}

.type-header {
  color: #FFFFFF;
  background-color: #009e0f;
  cursor: pointer;
  padding: 3px 6px;
  border-radius: 3px;

  i {
    font-size: 24px;
  }
}


</style>